import { EditProjectContextProps } from "../../EditProjectContext";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { getSupplierTransitTime } from "./GetSupplierTransitTime";
import { setLtlBidpackAndShipFrequency } from "./SetLtlBidpackAndShipFrequency";

export const toggleJitKanban = (
  editProjectContext: EditProjectContextProps,
  spdrOrPdsrId: number | undefined
) => {
  if (!spdrOrPdsrId) {
    return;
  }
  const { project, setProject } = editProjectContext;
  let ltlpipeline = {};
  const ltlPipelines = project?.ltlPipelines?.map((item: LtlPipelineViewModel) => {
    if (item.SpdrId !== spdrOrPdsrId && item.PdsrId !== spdrOrPdsrId) {
      return item;
    }

    const jitKanban = !item.JitKanban;

    if (jitKanban) {
      ltlpipeline = {
        ...item,
        SupplierTransitTime: "0",
        TTAdjustment: 0.1,
        JitKanban: jitKanban,
      };
      return ltlpipeline;
    }
    ltlpipeline = {
      ...item,
      JitKanban: jitKanban,
      SupplierTransitTime: getSupplierTransitTime(item.routing, item.TTAdjustment).toString(),
    };
    return ltlpipeline;
  });
  setLtlBidpackAndShipFrequency(spdrOrPdsrId, ltlpipeline, editProjectContext);
  setProject({ ...project, ltlPipelines });
};
